module.exports = __webpack_public_path__ + "img/checkgreen.05c06e90.svg";